import { Component, OnInit } from '@angular/core';
import { PortfolioService } from './portfolio-review.service';
import { UrlSignature } from '../common/apiEndPoint';
import { Router } from '@angular/router';
import { UtilService } from '../common/util.service';
import { Portfolio } from './portfolio';
import { CommonService } from '../common/common.service';

@Component({
  selector: 'app-portfolio-review',
  templateUrl: './portfolio-review.component.html',
  styleUrls: ['./portfolio-review.component.scss'],
})
export class PortfolioReviewComponent implements OnInit {
  personId: string = '';
  portfolioList: Portfolio[] = [];
  acdtUrl: string = '';
  duplicatePortfolio = true;

  constructor(
    private router: Router,
    private portfolioService: PortfolioService,
    private urlSignature: UrlSignature,
    private utilService: UtilService,
    private commonService: CommonService
  ) {}

  ngOnInit() {
    this.personId = localStorage.getItem('personId') || '';

    this.acdtUrl = this.urlSignature.acdtUrl + '/attachments_' + this.urlSignature.environment;
    this.portfolioService.getPortfolioList(this.personId).subscribe((response) => {
      this.portfolioList = response;
      this.portfolioList.forEach((portfolio) => {
        portfolio.portfolio = portfolio.attachment.substring(portfolio.attachment.indexOf('_') + 1);
        portfolio.attachmentLink =
          this.urlSignature.acdtUrl +
          '/attachments' +
          this.urlSignature.environment +
          '/portfolios/' +
          portfolio.attachment;
        if (portfolio.attachment.endsWith('.pdf')) {
          portfolio.attachmentUrl = this.urlSignature.acdtUrl + '/img/Adobe-PDF-Document-icon.png';
        } else {
          portfolio.attachmentUrl =
            this.urlSignature.acdtUrl +
            '/attachments' +
            this.urlSignature.environment +
            '/portfolios/' +
            portfolio.attachment;
        }
      });
    });
  }

  savePortfolio(page: string) {
    let validTitleName = this.validPortfolioName();
    this.duplicatePortfolio = this.checkDuplicatePortfolio();
    if (validTitleName && this.duplicatePortfolio) {
      this.portfolioService.savePortfolioDetails(this.portfolioList).subscribe((response) => {
        console.log(response);
        this.router.navigateByUrl('/' + page);
      });
    }
  }

  validatePortfolioName(event: any, index: number) {
    let validatePortfolioName = '';
    if (!this.utilService.validateExamIndexNo(event.target.value)) {
      validatePortfolioName = 'No special characters allowed only a-z A-Z 0-9';
    }
    this.portfolioList[index].validTitle = validatePortfolioName;
  }

  validPortfolioName() {
    for (let i = 0; i < this.portfolioList.length; i++) {
      if (this.portfolioList[i].validTitle !== undefined && this.portfolioList[i].validTitle.length > 0) {
        return false;
      }
    }
    return true;
  }

  checkDuplicatePortfolio() {
    for (let i = 0; i < this.portfolioList.length; i++) {
      for (let j = i + 1; j < this.portfolioList.length; j++) {
        if (this.portfolioList[i].portfolio === this.portfolioList[j].portfolio) {
          this.portfolioList[j].fileErrorMsg = 'This portfolio is already uploaded ';
          return false;
        }
      }
    }
    return true;
  }

  addPortfolio() {
    let portfolio = new Portfolio();
    portfolio.personId = this.personId;
    this.portfolioList.push(portfolio);
  }

  deletePortfolio(index: number) {
    if (this.portfolioList[index].portfolioId !== undefined) {
      this.portfolioService.deletePortfolio(this.portfolioList[index].portfolioId);
    }
    this.portfolioList.splice(index, 1);
  }

  handleFileInput(file: any, index: number) {
    let fileObject = file[0];
    let fileName = file[0].name;
    let fileSize = file[0].size / 1024;
    // upload the file into the server
    var form = new FormData();
    fileName = this.personId + '_' + fileName;
    form.append('Filename', fileName);
    form.append('file', fileObject);
    form.append('Upload', 'Submit Query');

    if (
      !(
        fileName.endsWith('.heic') ||
        fileName.endsWith('.HEIC') ||
        fileName.endsWith('.jpg') ||
        fileName.endsWith('.JPG') ||
        fileName.endsWith('.png') ||
        fileName.endsWith('.PNG') ||
        fileName.endsWith('.jpeg') ||
        fileName.endsWith('.JPEG') ||
        fileName.endsWith('.gif') ||
        fileName.endsWith('.GIF') ||
        fileName.endsWith('.pdf') ||
        fileName.endsWith('.PDF')
      )
    ) {
      this.portfolioList[index].fileErrorMsg = 'Only images of type PNG/GIF/JPG/JPEG/PDF allowed., ';
    } else if (fileSize / 1024 > 1) {
      this.portfolioList[index].fileErrorMsg = 'Only images of 1 MB is allowed., ';
    } else {
      this.commonService.uploadFiles(fileName, 'portfolios', form).subscribe((response) => {
        console.log(response);
        if (response === 'Success') {
          this.portfolioList[index].attachmentLink =
            this.urlSignature.acdtUrl + '/attachments' + this.urlSignature.environment + '/portfolios/' + fileName;
          if (fileName.endsWith('.pdf')) {
            this.portfolioList[index].attachmentUrl = this.urlSignature.acdtUrl + '/img/Adobe-PDF-Document-icon.png';
          } else {
            this.portfolioList[index].attachmentUrl =
              this.urlSignature.acdtUrl + '/attachments' + this.urlSignature.environment + '/portfolios/' + fileName;
          }
          this.portfolioList[index].attachment = fileName;
          this.portfolioList[index].portfolio = file[0].name;
          this.portfolioList[index].fileErrorMsg = '';
        }
      });
    }
  }
}